import React, { ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps } from '../../../helpers/withRouter'
import Switch from 'react-switch'
import { Button, Page } from '../../../components'
import { images } from '../../../images'
import literalsService from '../../../services/literals-service'
import { changeConfirmationFlagAction, changeFeedbackFlagAction, saveUserInfoAction, setNotificationAction } from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import theme from '../../../theme'
import StyledArticle from './styles'
import { appsStyleSelected } from '../../../helpers/app'
import { AuthenticatedRoutable } from '../../../models'
import { AnyAction } from 'redux'

interface IProps extends RouteComponentProps, DispatchProp<any> {
  notificationFeedback: boolean
  notificationReservationConfirmation: boolean
  isLoadingUserInfo: boolean
}

class NotificationSettings extends AuthenticatedRoutable<IProps> {

  public componentDidMount() {
    super.componentDidMount()
  }

  public render(): ReactNode {
    const { notificationFeedback, notificationReservationConfirmation } = this.props
    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            <img src={ images['goBack'] } className='backButton' onClick={ this.handleGoBack } />
            <form onSubmit={ e => e.preventDefault() }>
              <section>
                <h3>{ literalsService.get('notificationSettings', true) }</h3>
                <section>
                  <section className='row'>
                    <span>{ literalsService.get('infoNotificationFlag', true) }</span>
                    <Switch 
                      className='react-switch'
                      onChange={this.changeInfoNotificationFlag}
                      checked={notificationReservationConfirmation}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      onHandleColor={theme.colors.primary}
                      offHandleColor={theme.colors.primary}
                      onColor={theme.colors.secondary}>
                    </Switch>
                  </section>
                  <section className='row'>
                  <span>{ literalsService.get('rateNotificationFlag', true) }</span>
                    <Switch
                      className='react-switch'
                      onChange={this.changeFeedbackNotificationFlag}
                      checked={notificationFeedback}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      onHandleColor={theme.colors.primary}
                      offHandleColor={theme.colors.primary}
                      onColor={theme.colors.secondary}>
                    </Switch>
                  </section>
                </section>
                <Button
                  title={ literalsService.get('save', true) }
                  onPress={ () => this.saveUserInfo() }
                  className={ 'saveButton' }
                  filled
                  upper
                />
              </section>
            </form>
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    history.back()
  }

  private changeFeedbackNotificationFlag = () => {
    this.props.dispatch(changeFeedbackFlagAction())
  }

  private changeInfoNotificationFlag = () => {
    this.props.dispatch(changeConfirmationFlagAction())
  }

  private saveUserInfo = () => {
    const { dispatch } = this.props
    dispatch(saveUserInfoAction())
    dispatch(setNotificationAction({
      label: literalsService.get('notificationsChanged', true),
      isError: false
    }))
    this.handleGoBack()
  }
}

const mapStateToProps = ({ userInfo }: IStoreState) => ({
  notificationFeedback: userInfo.notificationFeedback,
  notificationReservationConfirmation: userInfo.notificationReservationConfirmation,
  isLoadingUserInfo: userInfo.isLoadingUserInfo
})

export default connectRedux(mapStateToProps, NotificationSettings)
